import { mutations as TYPES } from "./types";
import newObsLocalData from "@/utils/newObsLocalData.js";

const mutations = {
  [TYPES.OBS_DISABLED_BROWSE_TEMPLATE]: (state, value) => {
    state.welcome.isDisabledBrowseTemplate = value;
  },
  [TYPES.OBS_GO_TO_STEP]: (state, {data, shopifyDomain}) => {
    state.welcome.currentStep = data;
    newObsLocalData.set(data, "currentStep", shopifyDomain)
  },
  [TYPES.OBS_PAGE_OBJECTIVE]: (state, {data, shopifyDomain}) => {
    state.welcome.data.pageObjective = data;
    newObsLocalData.set(data, "objective", shopifyDomain)
  },
  [TYPES.OBS_HOVER_PAGE_OBJECTIVE]: (state, {data}) => {
    state.welcome.hoverPageObjective = data;
  },
  [TYPES.OBS_ADD_INDUSTRY]: (state, {data, shopifyDomain}) => {
    const stateIndustries = state.welcome.data.industries;
    stateIndustries.push(data);
    newObsLocalData.set(stateIndustries, "industries", shopifyDomain)
  },
  [TYPES.OBS_REPLACE_INDUSTRY]: (state, {data, shopifyDomain}) => {
    state.welcome.data.industries = data;
    newObsLocalData.set(state.welcome.data.industries, "industries", shopifyDomain)
  },
  [TYPES.OBS_REMOVE_INDUSTRY]: (state, {data, shopifyDomain}) => {
    const length = state.welcome.data.industries.length;
    for(let i = 0; i < length; i++){ 
      state.welcome.data.industries[i] === data && state.welcome.data.industries.splice(i, 1);
    }
    newObsLocalData.set(state.welcome.data.industries, "industries", shopifyDomain)
  },
  [TYPES.OBS_OTHERS_OBJECTIVE]: (state, othersObjective) => {
    state.othersObjective = othersObjective;
  },
  [TYPES.OBS_RESET_DATA]: (state) => {
    state.welcome.data.industries = [];
    state.welcome.data.pageObjective = "";
    newObsLocalData.removeAll();
  },
  [TYPES.DO_GO_TO_STEP]: (state, payload) => {
    const {step} = payload;
    state.widget.currentStep = step;
  },
  [TYPES.DO_CLOSE_WIDGET_ON_BOARDING]: (state) => {
    state.widget.isClosed = true;
  },
  [TYPES.DO_OPEN_WIDGET_ON_BOARDING]: (state) => {
    state.widget.isClosed = false;
  },
  [TYPES.DO_UPDATE_JOB_ROLE]: (state, payload) => {
    const {value} = payload;
    state.widget.data.jobRole.type = value;
  },
  [TYPES.D0_UPDATE_BUSINESS_TYPE]: (state, payload) => {
    const {value} = payload;
    state.widget.data.businessType = value;
  },
  [TYPES.DO_UPDATE_IS_SUBMIT_STEP]: (state, payload) => {
     state.widget.isSubmitStep = payload;
  },
  [TYPES.DO_UPDATE_SUBMITTING_STATUS]: (state, payload) => {
    state.widget.submittingStatus = payload;
  },
  [TYPES.DO_UPDATE_JOB_ROLE_VALUE]: (state, payload) => {
    const {value} = payload;
    state.widget.data.jobRole.value = value;
  }
};

export default mutations;
